import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  AfterViewInit,
  EventEmitter,
  ChangeDetectorRef,
} from "@angular/core";
import { FormGroup, FormBuilder, Validators, FormControl } from "@angular/forms";
import { MatDialogRef, MatDialog } from "@angular/material/dialog";
import swal from "sweetalert2";
import { ProyectosService } from "src/app/proyectos/proyectos.service";
import { EmpleadoService } from "src/app/empleado/empleado.service";
import { Persona } from "src/app/shared/model/security/persona.model";
import { Puesto } from "src/app/shared/model/empleado/puesto.model";
import { Usuario } from "src/app/shared/model/security/usuario.model";
import { ConsultaList } from "src/app/shared/model/core/ConsultaList.model";
import { Constantes } from "src/app/utilerias/constantes/constantes";
import { UtileriasService } from "src/app/utilerias/service/utilerias.service";
import { AuthService } from "src/app/security/auth.service";
import { Area } from "src/app/shared/model/empleado/area.model";
import { Cliente } from "src/app/shared/model/ajustesUsuario/cliente.model";
import { Proyecto } from "src/app/shared/model/gestion-proyectos/proyecto";
import {
  PaletaColoresEnum,
  PaletaColores,
} from "src/app/utilerias/enums/PaletaColoresEnum";
import { GenericoService } from "src/app/shared/services/generico.service";
import { UrlConstantes } from "src/app/utilerias/constantes/urlconstantes";
import { ActivatedRoute, Router } from "@angular/router";
import { Empleado } from "src/app/shared/model/empleado/empleado.model";
import { NuevosAlcancesComponent } from "../nuevos-alcances/nuevos-alcances.component";
import { Etapa } from "src/app/shared/model/gestion-proyectos/etapa/etapa";
import { nuevosAlcances } from "src/app/shared/model/gestion-proyectos/nuevosAlcances";
import { firstValueFrom, ReplaySubject } from "rxjs";
import { AvanceGrafiacaComponent } from "../avance-grafiaca/avance-grafiaca.component";
import { HistorialDeCambiosComponent } from "../historial-de-cambios/historial-de-cambios.component";
import { TipoServicio } from "src/app/shared/model/gestion-proyectos/tipoServicio";
import { DatatableCompatDirective } from 'src/app/shared/datatables-compat/datatable-compat.module';
import { HttpErrorResponse } from "@angular/common/http";
import { ConsultarOportunidadProyectoComponent } from "../consultar-oportunidad-proyecto/consultar-oportunidad-proyecto.component";
import { OportunidadesODPComponent } from "src/app/proceso-operativo/oportunidades/oportunidades-odp/oportunidades-odp.component";
import { ProductoCliente } from "src/app/shared/model/gestion-proyectos/productoCliente";
import { MatCheckbox, MatCheckboxChange } from "@angular/material/checkbox";
import { Servicio } from "src/app/shared/model/gestion-proyectos/servicio";
import moment from "moment";
import { ArchivosUtileriasService } from "src/app/utilerias/service/archivo-utilerias.service";
import { OperativoService } from "src/app/proceso-operativo/opeartivo.service";
import { Msg } from "src/app/utilerias/mensajes/Msg";
import { Config } from "datatables.net";

// Angular core y formularios
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";

// Angular Material
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatDialogModule } from "@angular/material/dialog";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule } from "@angular/material/core"; // ⬅ Necesario para que funcione el datepicker con fechas nativas

// Módulo de búsqueda dentro de mat-select
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";

// DataTables para Angular
import { DatatableCompatModule } from 'src/app/shared/datatables-compat/datatable-compat.module';
import {
  MatExpansionPanel,
  MatExpansionPanelActionRow,
  MatExpansionPanelDescription,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from "@angular/material/expansion";
import { MatListOption, MatSelectionList } from "@angular/material/list";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { AsigEmpComponent } from "./agregar-empleados-proyecto/add-emp-proy.component";
import { AzureService, ProyectoAzure } from "src/app/shared/services/azure-devops.service";
import {
  IntegranteLiberado,
  MotivoLiberacion,
} from "src/app/shared/model/gestion-proyectos/integrante-liberado";
import { rechazoDelGuardado } from "../../proyecto-pagina/etapas-versiones.util";
import { avisoArchivosSinLigar, mostrarRechazoDelGuardado } from "../../proyecto-pagina/rechazo-del-guardado";
import { rutaDeRegreso } from "../../proyecto-pagina/proyecto-pagina.rutas";

/** Carga perezosa de los proyectos de Azure DevOps para ligar el proyecto. */
type EstadoAzure = "sin-cargar" | "cargando" | "listo" | "error";

/** Lo que trae el campo de Azure DevOps: el proyecto elegido, el texto escrito o nada. */
export type ValorAzure = ProyectoAzure | string | null;

/** Renglón de solo lectura de "Integrantes liberados". */
export type IntegranteLiberadoVista = {
  nombre: string;
  detalle: string;
  motivo: string;
  claseMotivo: string;
  fecha: Date | null;
};

const MOTIVOS_LIBERACION: Record<MotivoLiberacion, { etiqueta: string; clase: string }> = {
  CIERRE_PROYECTO: { etiqueta: "Cierre del proyecto", clase: "is-inactive" },
  REMOVIDO: { etiqueta: "Retirado del equipo", clase: "is-pending" },
  BAJA_EMPLEADO: { etiqueta: "Baja del empleado", clase: "is-danger" },
};

/** Minúsculas y sin acentos, para buscar «diseno» y encontrar «Diseño». */
function sinAcentos(texto: string | null | undefined): string {
  return (texto ?? "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();
}

/** Proyectos de Azure cuyo nombre contiene lo escrito (sin importar acentos). */
export function filtraProyectosAzure(proyectos: ProyectoAzure[], texto: string): ProyectoAzure[] {
  const buscado = sinAcentos(texto);
  return buscado ? proyectos.filter((p) => sinAcentos(p.nombre).includes(buscado)) : proyectos;
}

/**
 * Liga con Azure DevOps que se manda al guardar, o null para no tocar la que
 * trae el proyecto (el backend conserva la guardada cuando llega null).
 * Solo se quita (se manda "") si el usuario la desvinculó a propósito con
 * "Sin vincular" o "Quitar la liga": texto escrito sin elegir no la quita.
 */
export function ligaAzureParaGuardar(
  valor: ValorAzure,
  desvincular: boolean,
): { idProyectoAzure: string; nombreProyectoAzure: string } | null {
  if (valor && typeof valor === "object" && valor.id) {
    return { idProyectoAzure: valor.id, nombreProyectoAzure: valor.nombre ?? "" };
  }
  return desvincular ? { idProyectoAzure: "", nombreProyectoAzure: "" } : null;
}

/** Integrantes liberados para la tabla de solo lectura, el más reciente primero. */
export function vistaIntegrantesLiberados(
  liberados: IntegranteLiberado[] | null | undefined,
): IntegranteLiberadoVista[] {
  return (Array.isArray(liberados) ? liberados : [])
    .filter(Boolean)
    .map((liberado) => {
      const motivo = MOTIVOS_LIBERACION[liberado.motivo] ?? {
        etiqueta: liberado.motivo || "Sin motivo",
        clase: "is-inactive",
      };
      const fecha = liberado.fechaLiberacion ? new Date(liberado.fechaLiberacion) : null;
      return {
        nombre:
          liberado.empleado?.persona?.nombreCompleto ||
          liberado.empleado?.usuario?.user_nom ||
          "Sin nombre",
        detalle:
          liberado.origen === "ETAPA"
            ? `Etapa ${liberado.nombreEtapa || "sin nombre"}`
            : "Equipo del proyecto",
        motivo: motivo.etiqueta,
        claseMotivo: motivo.clase,
        fecha: fecha && !Number.isNaN(fecha.getTime()) ? fecha : null,
      };
    })
    .sort((a, b) => (b.fecha?.getTime() ?? 0) - (a.fecha?.getTime() ?? 0));
}

type AdminProyectosListState = {
  currentPage?: number;
  pageSize?: number;
  nomProyecto?: string;
  clientefl?: string;
  selectAreaId?: number | null;
  formAreaSearch?: string;
  formClienteSearch?: string;
};

type ProjectWizardStep = {
  index: number;
  label: string;
  description: string;
};

@Component({
  selector: "app-modal-agregar-proyecto",
  templateUrl: "./modal-agregar-proyecto.component.html",
  styleUrls: ["./modal-agregar-proyecto.component.css"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatDialogModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgxMatSelectSearchModule,
    DatatableCompatModule,
    MatExpansionPanel,
    MatExpansionPanelActionRow,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatExpansionPanelDescription,
    AsigEmpComponent,
    MatCheckbox,
    MatSelectionList,
    MatListOption,
    MatAutocompleteModule,
  ],
})
export class ModalAddProyComponent implements OnInit, AfterViewInit {
  /**
   * **********************************************************************************************
   * BEGIN  Objects
   * **********************************************************************************************.
   */
  @ViewChild("nameProjectCtrl") inputStageCtrl: ElementRef;
  step: number;
  maxStepReached = 0;
  data: Proyecto = new Proyecto();
  formStageEmployee: FormGroup;
  objectEtapa: Proyecto;
  proyecto: Proyecto;
  isValid = false;
  listArea: Area[];
  clientes: Cliente[];
  requestEmpleados = new ConsultaList<Empleado>();

  recursosDesarollo: Empleado[];

  minDate: Date;
  titleModal = "Crear proyecto";
  titleModalServ = "Crear servicio";
  modeEditable: boolean = false;
  deshabilitar: boolean = false;

  paletaColores = [];
  alcances: Array<nuevosAlcances>;
  listLider: Empleado[];
  verGraficas: boolean = false;
  fechaInicio: string;
  fechaFin: string;
  tipoOpciones = ["PROYECTO", "SERVICIO", "OPORTUNIDAD"];
  estatusProyecto = ["ACTIVO", "CERRADO", "PAUSADO"];
  finProyecto: boolean = false;
  dialogRefNota: MatDialogRef<any>;
  versionesPorTipo: Map<number, string> = new Map<number, string>();
  nuevoAlcanceBtnOculto: boolean = false;
  tipoServicio: TipoServicio[] = [];
  alcanceGuardado: EventEmitter<any> = new EventEmitter<any>();
  idGenerado: any;
  idProyectoIngresado: string;
  contadorProyectos: number = 0;
  generarIdBtn: boolean = false;
  ultimoNumeroUtilizado = 0;
  dt: Config = {};
  @ViewChild(DatatableCompatDirective)
  dataElement: DatatableCompatDirective;
  oportunidadSeleccionada: any;
  fecha_creacion = new Date();
  usarOportunidad: boolean = false;
  idExistente: boolean = false;
  idProyectoEt: string;
  listProducto: ProductoCliente[] = [];
  esNuevoProducto: boolean = false;
  producto: ProductoCliente = new ProductoCliente();
  idProductoSelect: number;
  listServicios: Servicio[] = [];
  idClienteRelacionado: number;
  idServicioSeleccionado: number;
  idGeneradoExito: boolean = false;
  idMostrar: boolean = false;
  listaVoboAgregarSelect: any[] = [];
  listaArchivosAgregar: any[] = [];
  /**
   * Los archivos que ya se subieron a GitLab y que el proyecto todavía no
   * lista porque el guardado se rechazó (§5.8 A). Ya están en
   * proyecto.archivos: otro intento no los vuelve a subir ni a agregar.
   */
  private archivosSinLigar: string[] = [];
  editorReady = false;
  /** Liga con Azure DevOps: el proyecto elegido, o el texto mientras se escribe. */
  azureCtrl = new FormControl<ValorAzure>(null);
  proyectosAzure: ProyectoAzure[] = [];
  proyectosAzureFiltrados: ProyectoAzure[] = [];
  estadoAzure: EstadoAzure = "sin-cargar";
  /** true solo si el usuario quitó la liga ("Sin vincular" o "Quitar la liga"). */
  private azureDesvinculado = false;
  /** Quienes ya salieron del equipo (los administra el backend); solo lectura. */
  integrantesLiberados: IntegranteLiberadoVista[] = [];
  private listState: AdminProyectosListState | null = null;
  private currentRolePrefix = "ODP";
  /** A dónde regresar al terminar (state.returnUrl, p. ej. la página del proyecto); null = la lista. */
  private returnUrl: string | null = null;
  private readonly listStateStorageKey = "adm-proyectos:list-state";

  /**
   * **********************************************************************************************
   * BEGIN  Angular
   * **********************************************************************************************.
   */
  constructor(
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private proyectosService: ProyectosService,
    private empleadosService: EmpleadoService,
    private generico: GenericoService,
    private utilerias: UtileriasService,
    private archivoUtils: ArchivosUtileriasService,
    private operativoService: OperativoService,
    private authS: AuthService,
    private router: Router,
    private dialog: MatDialog,
    private modalDialog: MatDialog,
    private msg: Msg,
    private cdr: ChangeDetectorRef,
    private azureService: AzureService,
  ) {}

  ngOnInit() {
    this.formStageEmployee = this.formBuilder.group({
      nameProjectCtrl: ["", Validators.required],
      nameProjectShortCtrl: ["", Validators.required],
      areaProjectCtrl: ["", Validators.required],
      customerCtrl: ["", Validators.required],
      dateStartCtrl: ["", Validators.required],
      colorCtrl: [""],
      dateEndCtrl: ["", Validators.required],
      descriptionProjectCtrl: [""],
      horasProyecto: ["", Validators.required],
      horasEtc: [""],
      bossCtrl: [""],
      claveProyecto: [""],
      tipo: [""],
      requerimiento: [""],
      observaciones: [""],
      aplicacion: ["", [Validators.maxLength(60), Validators.pattern("^[a-zA-Z0-9áéíóúüñÁÉÍÓÚÜÑ /-]*$")]],
      estatus: ["ACTIVO", Validators.required],
      id_tipoServicio: [""],
      nombreProducto: [""],
      productoCtrl: [""],
      servicioCtrl: [""],
    });
    this.azureCtrl.valueChanges.subscribe(() => this.filtraAzure());

    this.requestEmpleados = new ConsultaList<Empleado>();
    this.requestEmpleados.regXPagina = 1000;
    this.requestEmpleados.regInicial = 0;
    this.requestEmpleados.bean = new Empleado();
    this.requestEmpleados.bean.usuario = new Usuario();
    this.requestEmpleados.bean.persona = new Persona();
    this.requestEmpleados.bean.puesto = new Puesto();
    queueMicrotask(() => {
      this.bootstrapEditor().catch((error) => {
        console.error("No fue posible inicializar el editor de proyectos.", error);
        this.showProjectUnavailableMessage(
          "No fue posible abrir la pantalla. Intente nuevamente desde la administracion.",
        );
      });
    });
  }

  ngAfterViewInit(): void {
    this.isValid = false;
    this.syncEditStatus();
  }

  get entityLabel(): string {
    if (this.data?.tipo === "SERVICIO") {
      return "Servicio";
    }

    if (this.data?.tipo === "OPORTUNIDAD") {
      return "Oportunidad";
    }

    return "Proyecto";
  }

  get pageTitle(): string {
    return `${this.modeEditable ? "Edicion" : "Alta"} de ${this.entityLabel}`;
  }

  get canAdvanceProjectStep(): boolean {
    return this.isProjectStepReady();
  }

  get hasAdditionalScopeStep(): boolean {
    return this.nuevoAlcanceBtnOculto;
  }

  get wizardSteps(): ProjectWizardStep[] {
    const steps: ProjectWizardStep[] = [
      {
        index: 0,
        label: "Proyecto",
        description: "Complete los datos principales.",
      },
      {
        index: 1,
        label: "Equipo",
        description: "Asigne colaboradores al proyecto.",
      },
      {
        index: 2,
        label: "Documentos",
        description: "Adjunte y consulte archivos del proyecto.",
      },
    ];

    if (this.hasAdditionalScopeStep) {
      steps.push({
        index: 3,
        label: "Alcances",
        description: "Revise o capture nuevos alcances.",
      });
    }

    return steps;
  }

  private async bootstrapEditor(): Promise<void> {
    const ready = await this.initializeRouteContext();
    if (!ready) {
      return;
    }

    this.consultaTipoServicio();
    this.consultaAreas();
    this.consultaClientes();
    this.consultaPaletaColores();
    this.consultarLideresDesarrollo();
    if (this.data?.id != null) {
      this.consultaAlcance(this.data.id);
    }
    this.consultaServicios();

    if (this.data?.id) {
      this.titleModal = "Editar proyecto: ";
      this.dt = {
        pagingType: "full_numbers",
        pageLength: 10,
        paging: false,
        serverSide: true,
        ajax: (dataTablesParameters: any, callback) => {},
      };
      this.step = 0;
      this.objectEtapa = this.data as Proyecto;
      this.proyecto = this.data;
      if (this.data.idProyecto != null && this.data.idProyecto != undefined) {
        this.idProyectoEt = this.data.idProyecto;
      }
      this.modeEditable = true;
      this.verGraficas = true;
      this.finProyecto = true;
      this.idGeneradoExito = true;
      this.validarCamposEditables();
      this.validarVoboRegistrado();
      this.syncEditStatus();
    } else {
      this.objectEtapa = new Proyecto();
      this.proyecto = new Proyecto();
      this.step = 0;
      this.modeEditable = false;
      this.verGraficas = false;
      this.data.tipo = "PROYECTO";
      this.data.estatus = "ACTIVO";
      this.formStageEmployee.patchValue({ estatus: "ACTIVO" });
    }

    this.onChangeTipo();
    this.muestraLigaAzureGuardada();
    this.integrantesLiberados = vistaIntegrantesLiberados(this.data?.integrantesLiberados);
    this.maxStepReached = this.modeEditable ? this.getLastWizardStepIndex() : 0;
    this.editorReady = true;
    this.cdr.detectChanges();
  }

  // Sin async (Sonar S7503: no espera nada), pero sigue dando una promesa: bootstrapEditor la espera.
  private initializeRouteContext(): Promise<boolean> {
    this.listState =
      (history.state?.listState as AdminProyectosListState) ||
      this.readStoredListState();
    this.currentRolePrefix = this.router.url.split("/")[1] || "ODP";
    this.returnUrl = rutaDeRegreso(history.state?.returnUrl);

    const isEditMode = this.route.snapshot.paramMap.has("id");
    const projectId = this.route.snapshot.paramMap.get("id");
    const proyectoState =
      (history.state?.proyecto as Proyecto | undefined) ??
      this.readStoredProjectState(projectId);

    if (isEditMode) {
      if (!proyectoState) {
        this.showProjectUnavailableMessage(
          "Seleccione nuevamente el proyecto desde la administracion para editarlo.",
        );
        return Promise.resolve(false);
      }

      this.data = this.hydrateProyecto(proyectoState);
      return Promise.resolve(true);
    }

    this.data = this.hydrateProyecto(new Proyecto());
    this.data.tipo = this.data.tipo || "PROYECTO";
    return Promise.resolve(true);
  }

  private showProjectUnavailableMessage(message: string): void {
    queueMicrotask(() => {
      swal
        .fire({
          title: "Informacion no disponible",
          text: message,
          buttonsStyling: false,
          customClass: {
            confirmButton: "btn btn-success",
          },
          confirmButtonText: "Aceptar",
          icon: "info",
        })
        .then(() => this.navigateBackToList());
    });
  }

  private syncEditStatus(): void {
    if (!this.data?.id || !this.formStageEmployee) {
      return;
    }

    const mapEstatus: Record<string, string> = {
      APROBADA: "ACTIVO",
      CERRADA: "CERRADO",
      PAUSADA: "PAUSADO",
    };

    const estatusBack = this.data.estatus?.trim().toUpperCase();

    this.formStageEmployee.patchValue({
      estatus: mapEstatus[estatusBack] || estatusBack,
    });
  }

  /**
   * **********************************************************************************************
   * BEGIN  Methods
   * **********************************************************************************************.
   */
  validarCamposEditables() {
    this.formStageEmployee.get("nameProjectCtrl").disable();
    this.formStageEmployee.get("nameProjectShortCtrl").disable();
    this.formStageEmployee.get("customerCtrl").disable();
  }

  validarVoboRegistrado() {
    if (!this.data?.tipoVobo) {
      this.msg.infoCall(
        "Le recordamos que el VOBO del cliente se encuentra pendiente",
        "Visto Bueno",
        {}
      );
    }
  }
  consultaPaletaColores(): void {
    firstValueFrom(
      this.generico.obtenerColeccion(UrlConstantes.OBTENER_PALETA_COLORES)
    )
      .then((res) => {
        this.paletaColores = res;
        this.cdr.detectChanges();
      });
  }

  consultaAreas(): void {
    this.empleadosService.consultaAreas().subscribe((res) => {
      this.listArea = res.list;
      this.cdr.detectChanges();
    });
  }

  consultaClientes(): void {
    this.proyectosService
      .findAllCustomers(new Cliente())
      .subscribe((response) => {
        if (response !== null && response !== undefined) {
          this.clientes = response;
        }
        this.cdr.detectChanges();
      });
  }

  clear(): void {
    if (!this.modeEditable) {
      this.data = this.hydrateProyecto(new Proyecto());
      this.data.tipo = "PROYECTO";
      this.data.estatus = "ACTIVO";
      this.objectEtapa = new Proyecto();
      this.proyecto = new Proyecto();
      this.idClienteRelacionado = null;
      this.idProductoSelect = null;
      this.idGenerado = null;
      this.idGeneradoExito = false;
      this.idProyectoEt = null;
      this.esNuevoProducto = false;
      this.listaArchivosAgregar = [];
      this.listaVoboAgregarSelect = [];
      this.azureCtrl.reset(null);
      this.azureDesvinculado = false;
      this.recursosDesarollo = undefined;
      this.formStageEmployee.reset({
        tipo: "PROYECTO",
        estatus: "ACTIVO",
      });
      this.step = 0;
      this.maxStepReached = 0;
      this.onChangeTipo();
      this.inputStageCtrl.nativeElement.focus();
    }
  }

  onNoClick(): void {
    this.navigateBackToList();
  }

  getColor(valor: string) {
    return PaletaColores.obtenerEnum(valor);
  }
  private obtenerListaArchivosAgregar(): any[] {
    let listaArchivos = [];
    this.listaArchivosAgregar.forEach((element) => {
      listaArchivos.push({
        name: "VOBO-" + element.name,
        type: element.type,
      });
    });
    return listaArchivos;
  }
  private obtenerRequestFileForm(idGit): FormData {
    const reqForm = new FormData();
    reqForm.append("idProyecto", idGit.toString());
    for (const archivo of this.listaArchivosAgregar) {
      reqForm.append("file", archivo, "VOBO-" + archivo.name);
    }
    return reqForm;
  }
  save(): void {
    this.proyecto = this.data;

    // El paso "Equipo" solo reporta si se abrió. Si no, se manda el equipo que
    // ya traía el proyecto: con undefined el backend guardaba colaboradores en
    // null y el equipo se perdía (y al cerrar no quedaba en el historial).
    this.proyecto.colaboradores = this.recursosDesarollo ?? this.objectEtapa?.colaboradores ?? [];
    const ligaAzure = ligaAzureParaGuardar(this.azureCtrl.value, this.azureDesvinculado);
    if (ligaAzure) {
      Object.assign(this.proyecto, ligaAzure);
    }
    this.clientes.forEach((element) => {
      if (element.id === this.data.idCliente) {
        this.proyecto.nombreCliente = element.razonsocial;
      }
    });
    this.listLider.forEach((element) => {
      if (element.idEmpleado === this.data.id_lider) {
        this.proyecto.nombreLider = element.persona.nombreCompleto;
        this.proyecto.usuarioLider = element.usuario.id;
      }
    });

    if (this.isValidDates()) {
      this.listArea.forEach((element) => {
        if (element.id === this.data.idArea) {
          this.proyecto.nomArea = element.area;
        }
      });

      if (this.proyecto.fecha_creacion == null) {
        this.proyecto.fecha_creacion = this.fecha_creacion;
      }

      this.proyecto.estatus = this.modeEditable
        ? this.formStageEmployee.get("estatus").value
        : "ACTIVO";
      if (this.idGenerado != null && this.idGenerado != undefined) {
        this.proyecto.idProyecto = this.idGenerado.idProyecto;
      }
      this.proyecto.producto = this.idProductoSelect;

      swal
        .fire({
          title: "Guardar proyecto",
          text: "¿Deseas continuar?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3f9142",
          cancelButtonColor: "#f44336",
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
        })
        .then((result) => {
          if (result.value) {
            if (this.listaArchivosAgregar.length > 0) {
              this.operativoService
                .guardarArchivoGit(
                  this.obtenerRequestFileForm(this.proyecto.idGit)
                )
                .subscribe((res: any) => {
                  if (res?.status && res.status === "ok") {
                    this.ligarArchivosSubidos();
                    this.guardarProyectoService();
                  }
                });
            } else this.guardarProyectoService();
          }
        });
    } else {
      swal.fire({
        title: "ERROR",
        text: "Por favor, ingrese un período de fechas válido...",
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger",
        },
        confirmButtonText: "Aceptar",
        icon: "warning",
      });
    }
  }

  /**
   * Los archivos nuevos ya están en el repositorio de GitLab: se agregan una
   * sola vez a proyecto.archivos (con el VoBo) y salen de la lista por subir.
   * Si el guardado se rechaza, otro intento ya no los sube ni los duplica.
   */
  private ligarArchivosSubidos(): void {
    const subidos = this.obtenerListaArchivosAgregar();
    this.proyecto.tipoVobo = "2";
    this.proyecto.archivos = this.proyecto.archivos?.length > 0 ? this.proyecto.archivos.concat(subidos) : subidos;
    this.archivosSinLigar = [...this.archivosSinLigar, ...subidos.map((archivo) => archivo.name)];
    this.listaArchivosAgregar = [];
    this.listaVoboAgregarSelect = [];
  }

  guardarProyectoService(): void {
    this.proyectosService.saveProyect(this.proyecto).subscribe((response) => {
      // Rechazos del guardado (etapas y versiones, §5.8): el servidor no guardó
      // nada, así que el editor se queda abierto con lo capturado. Los archivos
      // que el editor subió antes a GitLab sí quedaron allá.
      const rechazo = rechazoDelGuardado(response);
      if (rechazo) {
        mostrarRechazoDelGuardado(rechazo + avisoArchivosSinLigar(this.archivosSinLigar));
        return;
      }
      this.archivosSinLigar = [];
      var titulo;
      var texto;
      var icono;
      if (response.pCodRetorno === "00000") {
        titulo = "ÉXITO";
        texto = response.pMensaje;
        icono = "success";
      } else if (response.pCodRetorno.startsWith("244")) {
        //errores git
        titulo = "Guardado con errores";
        texto =
          "La oportunidad se ha guardado correctamente pero " +
          response.pMensaje.toLowerCase();
        icono = "warning";
      } else {
        titulo = "ERROR";
        texto = "Ocurrió un error al guardar la solicitud";
        icono = "error";
      }
      swal
        .fire({
          title: titulo,
          text: texto,
          buttonsStyling: false,
          customClass: {
            confirmButton: "btn btn-success",
            cancelButton: "btn btn-danger",
          },
          confirmButtonText: "Aceptar",
          icon: icono,
        })
        .then((abc) => {
          this.navigateBackToList();
          if (
            Constantes.DIEZ ===
            this.utilerias.convertirANumero(response.pCodRetorno)
          ) {
            this.authS.logout();
          }
        });
    });
  }

  registroHistorialDCambios(tipo: string, idtipo): void {
    this.dialogRefNota = this.modalDialog.open(HistorialDeCambiosComponent, {
      disableClose: true,
      autoFocus: true,
      maxHeight: "900px",
      width: "1000px",
      panelClass: "custom-modalbox",
      data: { tipo_cambio: tipo, id: idtipo },
    });

    this.dialogRefNota.afterClosed().subscribe((value) => {
      if (value !== null && value !== undefined) {
      }
      this.cdr.detectChanges();
    });
  }

  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }

  isValidDates(): boolean {
    if (!this.proyecto.fechaInicio || !this.proyecto.fechaFin) {
      return false;
    }

    const startDate = new Date(this.proyecto.fechaInicio);
    const endDate = new Date(this.proyecto.fechaFin);

    if (startDate.getTime() <= endDate.getTime()) {
      return true;
    } else {
      return false;
    }
  }

  agregarCliente() {
    this.generico.getEstatusPantalla(true);
    this.router.navigate(["CLIENTES/GESTION_CLIENTES"]);
  }

  agregarArea() {
    this.generico.getEstatusPantalla(true);
    this.router.navigate(["TICKETS/GestionAreas"]);
  }

  resourcesSelectedDevelopers(items: Array<Empleado>): void {
    this.recursosDesarollo = items;
    // "Agregar a todos" y "Limpiar asignación" entregan otro arreglo: se deja
    // como entrada para que al volver al paso "Equipo" se vea lo último.
    if (this.objectEtapa) {
      this.objectEtapa.colaboradores = items;
    }
  }

  /** Proyectos de Azure DevOps: se piden la primera vez que se usa el campo, o de nuevo tras un error. */
  cargarProyectosAzure(): void {
    if (this.estadoAzure === "cargando" || this.estadoAzure === "listo") {
      return;
    }
    this.estadoAzure = "cargando";
    this.azureService.getProyectosAzure(false).subscribe({
      next: (respuesta) => {
        const lista = Array.isArray(respuesta?.data) ? respuesta.data : null;
        if (lista) {
          this.proyectosAzure = lista
            .filter((p) => !!p?.id)
            .sort((a, b) => (a.nombre ?? "").localeCompare(b.nombre ?? "", "es"));
          this.estadoAzure = "listo";
          this.filtraAzure();
        } else {
          this.estadoAzure = "error";
        }
        this.cdr.detectChanges();
      },
      // Sin token de Azure o con Azure caído: aviso en el campo; el resto del formulario sigue igual.
      error: () => {
        this.estadoAzure = "error";
        this.cdr.detectChanges();
      },
    });
  }

  /**
   * Filtra con lo escrito. Con requireSelection el control no cambia mientras
   * se teclea, así que el texto llega del (input); sin texto (al elegir, al
   * quitar la liga o al cargar) se muestra la lista completa.
   */
  filtraAzure(texto = ""): void {
    this.proyectosAzureFiltrados = filtraProyectosAzure(this.proyectosAzure, texto);
  }

  /** Texto del campo: el nombre del proyecto elegido o lo que se va escribiendo. */
  muestraProyectoAzure = (valor: ValorAzure): string =>
    typeof valor === "string" ? valor : valor?.nombre ?? "";

  trackProyectoAzure(_indice: number, proyecto: ProyectoAzure): string {
    return proyecto.id;
  }

  get tieneLigaAzure(): boolean {
    const valor = this.azureCtrl.value;
    return !!valor && typeof valor === "object" && !!valor.id;
  }

  /** "Quitar la liga": al guardar se manda "" y el backend quita la liga. */
  desvincularAzure(): void {
    this.azureDesvinculado = true;
    this.azureCtrl.setValue(null);
    this.azureCtrl.markAsDirty();
  }

  /** Opción elegida de la lista: "Sin vincular" (null) quita la liga; un proyecto la cambia. */
  alElegirAzure(valor: ProyectoAzure | null): void {
    this.azureDesvinculado = valor === null;
  }

  /**
   * Al cerrar la lista sin elegir, requireSelection deja el campo en null.
   * Eso no quita la liga (se conserva la guardada), así que se vuelve a
   * mostrar la guardada para que la pantalla diga lo que se va a guardar.
   */
  alCerrarAzure(): void {
    if (!this.tieneLigaAzure && !this.azureDesvinculado) {
      this.muestraLigaAzureGuardada();
    }
  }

  get esEstatusCerrado(): boolean {
    return this.formStageEmployee?.get("estatus")?.value === "CERRADO";
  }

  /** Muestra la liga que ya trae el proyecto sin marcar el campo como cambiado. */
  private muestraLigaAzureGuardada(): void {
    this.azureDesvinculado = false;
    const id = this.data?.idProyectoAzure;
    this.azureCtrl.reset(
      id ? { id, nombre: this.data.nombreProyectoAzure || id } : null,
      { emitEvent: false },
    );
  }
  abrirModalParaAgregarNuevoAlcance(item: any): void {
    const dialogRef = this.dialog.open(NuevosAlcancesComponent, {
      height: "720px",
      width: "850px",
      panelClass: "custom-modalbox",
      data: item,
    });

    dialogRef.afterClosed().subscribe((datosDelAlcance) => {
      if (datosDelAlcance && Object.keys(datosDelAlcance).length > 0) {
        if (this.data) {
          this.data.nuevosAlcances.push(datosDelAlcance);
        } else {
          console.error("proyecto no está definido");
        }
      }
    });
  }

  consultarLideresDesarrollo(): void {
    this.requestEmpleados.bean.puesto.id = 1;
    this.requestEmpleados.bean.puesto.id_area = 1;
    this.empleadosService
      .consultaEmpleadosPorPuesto(this.requestEmpleados)
      .subscribe((response) => {
        if (response.list.length !== 0) {
          this.listLider = response.list;
        }
        this.cdr.detectChanges();
      });
  }

  selectedBoss(value) {
    this.sonRecursosValidos();
  }

  sonRecursosValidos(): void {
    this.isValid = this.recursosDesarollo && this.recursosDesarollo.length > 0;
  }

  consultaAvanceGrafica(proyecto: Proyecto) {
    this.dialog.open(AvanceGrafiacaComponent, {
      height: "720px",
      width: "800px",
      panelClass: "custom-modalbox",
      data: { proyecto: proyecto },
    });
  }

  consultaTipoServicio() {
    this.proyectosService
      .consultaGeneral(UrlConstantes.CONSULTA_TIPO_SERVICIO)
      .subscribe((res) => {
        if (res != null) {
          this.tipoServicio = res.list;
        }
        this.cdr.detectChanges();
      });
  }

  formatDate(date: Date | string): string {
    if (!date) {
      return "";
    }

    if (typeof date === "string") {
      date = new Date(date);
    }

    if (date instanceof Date && !Number.isNaN(date.getTime())) {
      return date.toLocaleDateString();
    } else {
      return "";
    }
  }

  generarBtn() {
    this.proyectosService
      .generarIdProyecto(
        this.idClienteRelacionado,
        this.idProductoSelect,
        this.idServicioSeleccionado
      )
      .subscribe(
        (response: string) => {
          this.idGenerado = response;
          if (response) {
            this.idGeneradoExito = true;
            if (this.data.idProyecto === undefined) {
              this.idProyectoEt = this.idGenerado.idProyecto;
            }
            swal.fire({
              title: "Se registró el Id: " + this.idGenerado.idProyecto,
              buttonsStyling: false,
              customClass: {
                confirmButton: "btn btn-success",
                cancelButton: "btn btn-danger",
              },
              confirmButtonText: "Aceptar",
              icon: "success",
            });
          }
        },
        (error) => {
          console.error("Error al generar el ID del proyecto:", error);
          this.cdr.detectChanges();
        }
      );
  }

  consultaAlcance(id: string | number) {
    this.proyectosService.consultaAlcance(String(id)).subscribe((res) => {
      this.alcances = res.list;
      this.cdr.detectChanges();
    });
  }

  seleccionCliente(event: any) {
    if (event.value) {
      const idCliente = event.value;
      this.idClienteRelacionado = idCliente;
      this.consultaProductosCliente(idCliente);
    }
  }

  consultaProductosCliente(idCliente: number) {
    this.proyectosService
      .obtenerProductosCliente(idCliente)
      .subscribe((response) => {
        this.listProducto = response.list;
        if (this.listProducto != null || this.listProducto != undefined) {
          this.esNuevoProducto = false;
        } else {
          this.esNuevoProducto = true;
        }
        this.cdr.detectChanges();
      });
  }

  nuevoProducto(valor: MatCheckboxChange) {
    if (valor.checked == true) {
      this.esNuevoProducto = true;
      this.idProductoSelect = null;
    } else {
      this.esNuevoProducto = false;
      this.idProductoSelect = null;
    }
  }

  guardaProducto() {
    this.producto.id_cliente = this.formStageEmployee.get("customerCtrl").value;
    this.producto.estatus = "ACTIVO";
    this.producto.producto = this.formStageEmployee.get("nombreProducto").value;
    this.proyectosService
      .guardaProductoCliente(this.producto)
      .subscribe((response) => {
        if (response) {
          swal.fire({
            title: "El producto se registró exitosamente",
            buttonsStyling: false,
            customClass: {
              confirmButton: "btn btn-success",
              cancelButton: "btn btn-danger",
            },
            confirmButtonText: "Aceptar",
            icon: "success",
          });
          this.idMostrar = true;
        }
        this.idProductoSelect = response.id_producto;
        if (this.idProductoSelect) {
          this.consultaProductosCliente(this.idClienteRelacionado);
          this.esNuevoProducto = false;
        }
      });
  }

  seleccionarProducto(event: any) {
    this.idProductoSelect = event.value;
  }

  consultaServicios() {
    this.proyectosService.obtenerServicios().subscribe((response) => {
      if (response !== null && response !== undefined) {
        this.listServicios = response.list;
      }
      this.cdr.detectChanges();
    });
  }

  seleccionarServicio(event: any) {
    this.proyecto.servicio = event.value;
    this.idServicioSeleccionado = this.proyecto.servicio;
    if (
      this.idClienteRelacionado &&
      this.idProductoSelect &&
      this.idServicioSeleccionado
    ) {
      this.generarBtn();
    } else {
      this.formStageEmployee.get("servicioCtrl").setValue("");
      swal.fire({
        title:
          "Algún dato no ha sido seleccionado; verificar el cliente, producto o servicio.",
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger",
        },
        confirmButtonText: "Aceptar",
        icon: "error",
      });
    }
  }

  validarDias() {
    const fechaInicio = this.formStageEmployee.get("dateStartCtrl")?.value;
    const fechaFin = this.formStageEmployee.get("dateEndCtrl")?.value;

    if (fechaInicio && fechaFin) {
      const fechaInicioMoment = moment(fechaInicio);
      const fechaFinMoment = moment(fechaFin);
      if (fechaFinMoment.isBefore(fechaInicioMoment)) {
        this.formStageEmployee.get("dateEndCtrl").setValue("");
        swal.fire({
          icon: "error",
          title: "Error",
          text: "La fecha de fin no puede ser menor a la fecha de inicio.",
          confirmButtonText: "Aceptar",
        });
        return;
      }
    }
  }

  descargarArchivo(nombre, tipo) {
    const data = {
      idGitProyecto: this.data.idGit,
      nombreArchivo: nombre,
    };
    this.operativoService.muestraEvidencia(data).subscribe((res) => {
      if (res) {
        this.archivoUtils.descargarArchivo(res.content, res.name, tipo);
      } else
        this.msg.showErrorNotification(
          "top",
          "No fue posible descargar el archivo"
        );
    });
  }

  public cargarVobo() {
    this.listaArchivosAgregar = this.archivoUtils.agregarCargaArchivo(
      "nameFileArchivo",
      this.listaArchivosAgregar,
      /.*/
    );
  }

  public removerVobo() {
    this.listaArchivosAgregar = this.archivoUtils.removerCargaArchivo(
      "nameFileArchivo",
      this.listaArchivosAgregar,
      this.listaVoboAgregarSelect
    );
    this.listaVoboAgregarSelect = [];
  }
  public onNgModelChangeArchivo($event) {
    this.listaVoboAgregarSelect = $event;
  }

  onChangeTipo(): void {
    const tipo = this.data?.tipo;
    const tipoServicio = this.formStageEmployee.get("id_tipoServicio");
    const horasProyecto = this.formStageEmployee.get("horasProyecto");

    tipoServicio?.clearValidators();
    horasProyecto?.clearValidators();

    tipoServicio?.reset(null);
    horasProyecto?.reset(null);

    if (tipo === "SERVICIO") {
      tipoServicio?.setValidators(Validators.required);
      // Un servicio sin hrs contratadas es un escenario válido (p. ej. servicios sin
      // tope de horas), así que el campo es opcional; si se captura, debe ser >= 0.
      horasProyecto?.setValidators(Validators.min(0));
    }
    if (tipo === "PROYECTO") {
      horasProyecto?.setValidators([Validators.required, Validators.min(1)]);
    }

    tipoServicio?.updateValueAndValidity();
    horasProyecto?.updateValueAndValidity();
  }

  canAccessStep(index: number): boolean {
    if (!this.getVisibleWizardStepIndexes().includes(index)) {
      return false;
    }

    if (this.modeEditable) {
      return true;
    }

    if (index <= this.maxStepReached) {
      return true;
    }

    return index === 1 && this.isProjectStepReady();
  }

  goToStep(index: number): void {
    if (!this.canAccessStep(index)) {
      return;
    }

    this.step = index;
    this.maxStepReached = Math.max(this.maxStepReached, index);
  }

  goToNextStep(): void {
    if (this.step === 0 && !this.isProjectStepReady()) {
      this.formStageEmployee.markAllAsTouched();
      return;
    }

    const visibleSteps = this.getVisibleWizardStepIndexes();
    const currentIndex = visibleSteps.indexOf(this.step);
    const nextStepIndex = visibleSteps[currentIndex + 1];

    if (nextStepIndex != null) {
      this.goToStep(nextStepIndex);
    }
  }

  goToPreviousStep(): void {
    const visibleSteps = this.getVisibleWizardStepIndexes();
    const currentIndex = visibleSteps.indexOf(this.step);
    const previousStepIndex = visibleSteps[currentIndex - 1];

    if (previousStepIndex != null) {
      this.step = previousStepIndex;
    }
  }

  private isProjectStepReady(): boolean {
    return !!this.formStageEmployee && this.formStageEmployee.valid;
  }

  private getVisibleWizardStepIndexes(): number[] {
    return this.wizardSteps.map((wizardStep) => wizardStep.index);
  }

  private getLastWizardStepIndex(): number {
    const visibleSteps = this.getVisibleWizardStepIndexes();
    return visibleSteps[visibleSteps.length - 1] ?? 0;
  }

  private navigateBackToList(): void {
    if (this.returnUrl) {
      this.router.navigateByUrl(this.returnUrl);
      return;
    }
    const navigationExtras = this.listState
      ? { state: { listState: this.listState } }
      : undefined;

    this.router.navigate([this.getListRoute()], navigationExtras);
  }

  private readStoredListState(): AdminProyectosListState | null {
    const rawState = sessionStorage.getItem(this.listStateStorageKey);
    if (!rawState) {
      return null;
    }

    try {
      return JSON.parse(rawState) as AdminProyectosListState;
    } catch {
      sessionStorage.removeItem(this.listStateStorageKey);
      return null;
    }
  }

  private readStoredProjectState(projectId: string | null): Proyecto | undefined {
    if (!projectId) {
      return undefined;
    }

    const rawState = sessionStorage.getItem(this.getProjectStorageKey(projectId));
    if (!rawState) {
      return undefined;
    }

    try {
      return JSON.parse(rawState) as Proyecto;
    } catch {
      sessionStorage.removeItem(this.getProjectStorageKey(projectId));
      return undefined;
    }
  }

  private getListRoute(): string {
    if (this.router.url.includes("/VISUALIZARPROY")) {
      return this.currentRolePrefix === "VISUALIZARPROY"
        ? "/VISUALIZARPROY"
        : `/${this.currentRolePrefix}/VISUALIZARPROY`;
    }

    return `/${this.currentRolePrefix}/admproyectos`;
  }

  private getProjectStorageKey(projectId: number | string): string {
    return `adm-proyectos:${this.currentRolePrefix}:project:${projectId}`;
  }

  private hydrateProyecto(source: Proyecto): Proyecto {
    const hydrated = Object.assign(
      new Proyecto(),
      JSON.parse(JSON.stringify(source ?? {})),
    ) as Proyecto;

    hydrated.nuevosAlcances = Array.isArray(hydrated.nuevosAlcances)
      ? hydrated.nuevosAlcances
      : [];
    hydrated.archivos = Array.isArray(hydrated.archivos) ? hydrated.archivos : [];
    hydrated.colaboradores = Array.isArray(hydrated.colaboradores)
      ? hydrated.colaboradores
      : [];

    return hydrated;
  }
}
